import styled from "styled-components";
import theme from "../../../Styles/theme";

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
   

`;


export const Title = styled.h1`

text-align:center;
font-size: max(10px, 1.2vw);
color: ${theme.colors.dark};

margin-bottom:1vh;
`;


export const Footer = styled.footer`

display:flex;
align-items: center;
justify-content:space-between;

`;
export const Button = styled.button`
margin:auto;
color:${theme.colors.dark};
&:hover{
    opacity: 0.8;
}

`;


export const Conteudo = styled.div`

    display: flex;
    align-items: center;
    justify-content:space-around;

width: 100%;
margin-bottom:2vh;
`;

export const HelperSinalizadorDiv = styled.div`

display: flex;
align-items: center;
justify-content:center;

margin-bottom:0.5vh;
`;

export const HelperImage = styled.div`
 width: 100%;
 display: flex;
 align-items: center;
 justify-content:center;

`;
export const Image = styled.img`
    max-width: 80%;
    max-height:60vh;
    
    cursor: pointer;

    

`;

interface PropsChevronButton{
    disabled:boolean;
}
export const ChevronButton= styled.button<PropsChevronButton>`

    color: ${theme.colors.dark};
    cursor:${({disabled})=>disabled? 'not-allowed':'pointer'};
    opacity:${({disabled})=>disabled? 0.6:1};

`;